import { indexItems } from '@/mocks/homepage';

export default function IndexSection() {
  return (
    <section id="index" className="relative py-16 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">专题合集</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            按类型分类浏览，找到你最喜欢的电视剧专题
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item, idx) => (
            <div
              key={item.id}
              className={`group bg-background-100 border border-background-200/50 hover:border-background-300/60 rounded-xl p-5 md:p-6 text-center transition-all duration-200 cursor-pointer ${
                idx === 0 ? 'lg:col-span-2 lg:text-left lg:flex lg:items-center lg:gap-5 lg:p-6' : ''
              }`}
            >
              <span className={`inline-flex items-center justify-center rounded-xl mb-3 ${
                idx === 0 ? 'w-12 h-12 lg:mb-0 lg:flex-shrink-0' : 'w-11 h-11'
              } ${
                idx % 3 === 0 ? 'bg-primary-500/12' :
                idx % 3 === 1 ? 'bg-accent-500/12' :
                'bg-secondary-500/12'
              }`}>
                <i className={`${item.icon} text-xl ${
                  idx % 3 === 0 ? 'text-primary-400' :
                  idx % 3 === 1 ? 'text-accent-400' :
                  'text-secondary-400'
                }`}></i>
              </span>
              <div>
                <h3 className="text-sm md:text-base font-bold text-foreground-950 font-heading mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500">{item.count} · {item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}